// Attributes and classes TinyMCE writes onto the editable element and does NOT clean up on
// remove(), and the role and aria attributes `announceEditor` adds once the editor has started.
// Left behind, the element stays visibly editable after teardown while nothing syncs
// its content anywhere — edits typed into it would be silently discarded on submit.
export const RESIDUE_ATTRIBUTES = ["contenteditable", "spellcheck", "role", "aria-multiline", "aria-placeholder", "aria-labelledby"];

/**
 * Undoes what `tinymce.remove()` leaves on the editable element. remove() restores the
 * element's content but not its attributes, so without this the element keeps
 * `contenteditable="true"` and `class="mce-content-body"` after teardown.
 */
export function stripEditorResidue(editable: HTMLElement, originalClassName: string): void {
    for (const attribute of RESIDUE_ATTRIBUTES) {
        editable.removeAttribute(attribute);
    }

    for (const attribute of [...editable.attributes]) {
        if (attribute.name.startsWith("data-mce-")) {
            editable.removeAttribute(attribute.name);
        }
    }

    // TinyMCE sets an inline `position: relative` when the element was statically positioned.
    editable.style.removeProperty("position");
    editable.className = originalClassName;
}
